import { render, staticRenderFns } from "./virtualTable.vue?vue&type=template&id=17da3965&scoped=true"
import script from "./virtualTable.vue?vue&type=script&lang=js"
export * from "./virtualTable.vue?vue&type=script&lang=js"
import style0 from "./virtualTable.vue?vue&type=style&index=0&id=17da3965&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17da3965",
  null
  
)

export default component.exports